import ReactDOM from 'react-dom';

// Providers
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Router, Switch, Route } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

// Constants
import theme from './theme';
import apolloClient from 'apollo';

// Pages
import Showcase from 'pages/Showcase';
import Capture from 'pages/CaptureImages';

// Utilities
// import store from 'store';
import * as Sentry from '@sentry/react';
import history from 'constants/config/history';
import { Integrations } from '@sentry/tracing';
import excludeGqlFetchBreadcrumb from 'apollo/config/excludeGqlFetchBreadcrumb';
import DateFnsUtils from '@date-io/date-fns';

// Shims
import './shims';

// Css
import './index.css';

// Component
import App from './App';

const render = Component => {
  ReactDOM.render(
    <Router history={history}>
      <ApolloProvider client={apolloClient}>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Switch>
              <Route path="/showcase" component={Showcase} />
              <Route path="/capture" component={Capture} />
              <Route component={Component} />
            </Switch>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </ApolloProvider>
    </Router>,
    document.getElementById('root'),
  );
};

if (process.env.REACT_APP_ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn:
      'https://a8fea4b78c784594bb4cae320ddc1378@o74335.ingest.sentry.io/1250819',
    integrations: [
      // Perf monitoring
      new Integrations.BrowserTracing(),
      new Sentry.Integrations.Breadcrumbs({
        // Hide console.log due to the noise with redux-sagas
        console: false,
      }),
    ],
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: `my-cnc-web@${process.env.REACT_APP_VERSION}`,
    // Reduced sample rate to reduce impact on events quota
    tracesSampleRate: 0.01,
    // Remove classic http req capture for our gql endpoints, to not double count requests
    beforeBreadcrumb: excludeGqlFetchBreadcrumb,
    ignoreErrors: [
      'Jwt is expired',
      'The network connection was lost',
      'Jwt cannot be parsed',
      'Authentication failed',
    ],
    denyUrls: ['https://js-agent.newrelic.com/'],
  });
}

render(App);

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    render(NextApp);
  });
}
